import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import MultiSelect from './MultiSelect';
import { getCompanyType } from '../../redux/authSlice';

const FilterPanelForCompanies = ({ onFilter, onReset, className }) => {
  const dispatch = useDispatch();
  const companyTypes = useSelector(state => state.auth.companyType)|| []// Adjust according to your state structure
  const countriesOptions = [
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "China", label: "China" },
    { value: "India", label: "India" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Korea", label: "Korea" },
    { value: "Sri Lanka", label: "Sri Lanka" },
    { value: "Turkey", label: "Turkey" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Rest of World", label: "Rest of World" },
  ];

  const status_of_approval = [
    { value: "2", label: "Pending" },
    { value: "0", label: "Rejected" },
  ];
  const [searchValue, setSearchValue] = useState('');
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [statusFilter, setStatusFilter] = useState(2);
  const [companyTypeId, setCompanyTypeId] = useState('');

  useEffect(() => {
    dispatch(getCompanyType());
  }, [dispatch]);

  const handleSearchChange = (e) => setSearchValue(e.target.value);
  const handleCountriesChange = (selectedItems) => setSelectedCountries(selectedItems);
  const handleStatusFilterChange = (e) => setStatusFilter(e.target.value);
  const handleCompanyTypeChange = (e) => setCompanyTypeId(e.target.value);

  const handleFilter = () => {
    onFilter({
      search: searchValue,
      countries: selectedCountries,
      status: statusFilter,
      companyTypeId,
    });
  };

  const handleReset = () => {
    setSearchValue('');
    setSelectedCountries([]);
    setStatusFilter(2);
    setCompanyTypeId('');
    onReset();
  };
console.log("Values in filter",companyTypes)
  return (
    <div className={className}>
      <div className="card">
        <div className="card-body">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                label="Search"
                variant="outlined"
                value={searchValue}
                onChange={handleSearchChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} md={4}>
              {/* Assuming MultiSelect is properly implemented to handle multiple selections */}
              <MultiSelect
                options={countriesOptions}
                label="Select Countries"
                onChange={handleCountriesChange}
                value={selectedCountries}
                multiple
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="company-type-label">Company Type</InputLabel>
                <Select
                  labelId="company-type-label"
                  value={companyTypeId}
                  onChange={handleCompanyTypeChange}
                  label="Company Type"
                >
                    <MenuItem value="" disabled>
                          Select Company Type
                        </MenuItem>
                  {companyTypes.map((type) => (
                    <MenuItem key={type.companyTypeId} value={type.companyTypeName}>
                      {type.companyTypeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="status-filter-label">Status</InputLabel>
                <Select
                  labelId="status-filter-label"
                  value={statusFilter}
                  onChange={handleStatusFilterChange}
                  label="Status"
                >
                  {/* Populate with relevant options */}
                  {status_of_approval.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item container spacing={1} className="mt-2">
              <Grid item xs={1}>
                <button
                  className="btn btn-primary greeen-btn md_btn"
                  onClick={handleFilter}
                  fullWidth
                >
                  <span>
                    <FilterAltOutlinedIcon />
                  </span>
                  Filter
                </button>
              </Grid>
              <Grid item xs={1}>
                <button
                  className="btn btn-light grey-btn md_btn "
                  onClick={handleReset}
                >
                  <span>
                    <i className="bi bi-funnel"></i>
                  </span>
                  Reset
                </button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default FilterPanelForCompanies;
